// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"subtitle","title":"title"};